module.exports = __webpack_public_path__ + "img/win.65190724.png";